/**
 * Converts back and forth between hex SMPTE Universal Labels (UL), symbolic
 * names and MXF static local tags.
 *
 * Also provides categorization based on subsets of the symbolic names.
 */

export const SMPTE_UL_STRING_LENGTH = (16 * 3) - 1;
export const SMPTE_UL_INDEX_TABLE_SEGMENT = '06.0e.2b.34.02.53.01.01.0d.01.02.01.01.10.01.00';

export const SMPTE_UL_KLV_FILL =            '06.0e.2b.34.01.01.01.02.03.01.02.10.01.00.00.00';
export const SMPTE_UL_KLV_FILL_LEGACY =     '06.0e.2b.34.01.01.01.01.03.01.02.10.01.00.00.00';

export const SMPTE_UL_KLV_FILLS = new Set([
  SMPTE_UL_KLV_FILL,
  SMPTE_UL_KLV_FILL_LEGACY,
]);

// Table 4 – Partition Pack Key Value
// Table 6 – Specification of the Header Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.02.00';
export const SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION =     '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.03.00';
export const SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.04.00';

// Table 4 – Partition Pack Key Value
// Table 7 – Specification of the Body Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.02.00';
export const SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION =     '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.03.00';
export const SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.04.00';

// Table 4 – Partition Pack Key Value
// Table 8 – Specification of the Footer Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION =    '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION =  '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.02.00';
export const SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION =      '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.03.00';
export const SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION =    '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.04.00';

export const SMPTE_UL_RANDOM_INDEX_PACK = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.11.01.00';

export const SMPTE_UL_PARTITION_PACKS = new Set([
  SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION,
  SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION,
  SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION,
  SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION,
  SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION,
  SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION,
]);

export const SMPTE_UL_PRIMER_PACK = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.05.01.00';

export const SMPTE_PICTURE_ESSENCE_CODING_AVC_BASELINE =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.11.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_MAIN =                                       '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.20.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_EXTENDED =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.30.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH =                                       '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.40.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10 =                                    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.50.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422 =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.60.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444 =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.70.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA =                              '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.20.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_5994I =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_50I =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.02';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_2997P =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.03';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_25P =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.04';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_5994P =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.08';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_50P =     '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.09';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA =                             '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.30.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_5994I = '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_50I =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.02';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_2997P = '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.03';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_25P =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.04';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_5994P =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.08';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_50P =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.09';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444_INTRA =                             '06.0e.2b.34.04.01.01.0d.04.01.02.02.01.32.40.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_CAVLC_444 =                                  '06.0e.2b.34.04.01.01.0d.04.01.02.02.01.32.50.01';

export const SMPTE_UL_ESSENCE_ELEMENT_PREFIX = '06.0e.2b.34.01.02.01.01.0d.01.03.01.';

// First 13 bytes are defined by: SMPTE-379M-2004: Table 1
// Last 3 bytes are defined by: SMPTE-394M-2006: Table 2
export const SMPTE_UL_SYSTEM_SCHEME_1 = '06.0e.2b.34.02.53.01.01.0d.01.03.01.14.02.01.00';

// SMPTE ST 385:2012: Table 1
export const SMPTE_UL_SDTI_SYSTEM_METADATA = '06.0e.2b.34.02.05.01.01.0d.01.03.01.04.01.01.00';

export function isEssenceElement(ul: string): boolean {
  return (ul.length === SMPTE_UL_STRING_LENGTH) && ul.startsWith(SMPTE_UL_ESSENCE_ELEMENT_PREFIX);
}

export function extractEssenceTrack(ul: string): string | null {
  if ((ul.length === SMPTE_UL_STRING_LENGTH) && ul.startsWith(SMPTE_UL_ESSENCE_ELEMENT_PREFIX)) {
    return ul.slice(SMPTE_UL_ESSENCE_ELEMENT_PREFIX.length);
  } else {
    return null;
  }
}

export function isStructuralMetadataSet(ul: string): boolean {
  // Table 16 – Common Key Value for the Structural Metadata Sets
  const pattern : RegExp = /^06\.0e\.2b\.34\.02\.[0-9a-z]{2}\.01\.[0-9a-z]{2}\.0d\.01\.01\.01\.01\.[0-9a-z]{2}\.[0-9a-z]{2}\.00$/;
  return pattern.exec(ul) !== null;
}

export class MxfDictionary {
  private ulToName: Record<string, string> = {};
  private nameToUl: Record<string, string> = {};
  private ulToTag: Record<string, string> = {};
  private tagToUl: Record<string, string> = {};

  public constructor() {
    for (const name in DEFAULT_NAME_TO_UL) {
      const ul = DEFAULT_NAME_TO_UL[name];
      this.add(name, ul);
    }
    for (const localTag in INDEX_TABLE_STATIC_TAGS) {
      const ul = INDEX_TABLE_STATIC_TAGS[localTag];
      this.addLocalTag(localTag, ul);
    }
  }

  public add(name: string, ul: string) {
    this.nameToUl[name] = ul;
    this.ulToName[ul] = name;
  }

  public getName(ul: string): string | undefined {
    return this.ulToName[ul];
  }

  public getUl(name: string): string | undefined {
    return this.nameToUl[name];
  }

  public addLocalTag(localTag: string, ul: string) {
    this.tagToUl[localTag] = ul;
    this.ulToTag[ul] = localTag;
  }

  public getUlFromLocalTag(localTag: string): string | undefined {
    return this.tagToUl[localTag];
  }

  public getLocalTagFromUl(ul: string): string | undefined {
    return this.ulToTag[ul];
  }
}

// This dictionary has been extracted from SMPTE 377-1-2009. This is not
// complete has only been extended when a key is needed.
// References:
// * https://web.archive.org/web/20231212154231/https://raw.githubusercontent.com/juliusfriedman/net7mma/master/Reference/MXF-S377-1-2009.pdf

const DEFAULT_NAME_TO_UL : Record<string, string> = {
  'OpenAndIncompleteHeaderPartition'   : SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION,
  'ClosedAndIncompleteHeaderPartition' : SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION,
  'OpenAndCompleteHeaderPartition'     : SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION,
  'ClosedAndCompleteHeaderPartition'   : SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION,

  'OpenAndIncompleteBodyPartition'     : SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION,
  'ClosedAndIncompleteBodyPartition'   : SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION,
  'OpenAndCompleteBodyPartition'       : SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION,
  'ClosedAndCompleteBodyPartition'     : SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION,

  'OpenAndIncompleteFooterPartition'   : SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION,
  'ClosedAndIncompleteFooterPartition' : SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION,
  'OpenAndCompleteFooterPartition'     : SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION,
  'ClosedAndCompleteFooterPartition'   : SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION,

  // Table 13 – Primer Pack Key Value
  'PrimerPack'                         : SMPTE_UL_PRIMER_PACK,

  // 6.3.3 KLV Fill Items
  'KLVFill'                            : SMPTE_UL_KLV_FILL,
  'KLVFill(legacy)'                    : SMPTE_UL_KLV_FILL_LEGACY,

  // Table 16: Common Key Value for the Structural Metadata Sets
  // Table 17: Key Values for Structural Metadata Sets
  'Preface'                            : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.2f.00',
  'Identification'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.30.00',
  'ContentStorage'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.18.00',
  'EssenceContainerData'               : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.23.00',
  'MaterialPackage'                    : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.36.00',
  'SourcePackage'                      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.37.00',
  'TimelineTrack'                      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.3b.00',
  'EventTrack'                         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.39.00',
  'StaticTrack'                        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.3a.00',
  'Sequence'                           : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.0f.00',
  'SourceClip'                         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.11.00',
  'TimecodeComponent'                  : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.14.00',
  'DMSegment'                          : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.41.00',
  'DMSourceClip'                       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.45.00',
  'Filler'                             : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.09.00',
  'PackageMarkerObject'                : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.60.00',
  'FileDescriptor'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.25.00',
  'GenericPictureEssenceDescriptor'    : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.27.00',
  'ContainerDuration'                  : '06.0e.2b.34.01.01.01.01.04.06.01.02.00.00.00.00',
  'CDCIEssenceDescriptor'              : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.28.00',
  'RGBAEssenceDescriptor'              : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.29.00',
  'GenericSoundEssenceDescriptor'      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.42.00',
  'GenericDataEssenceDescriptor'       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.43.00',
  'MultipleDescriptor'                 : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.44.00',
  'NetworkLocator'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.32.00',
  'TextLocator'                        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.33.00',
  'ApplicationPluginObject'            : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.61.00',
  'ApplicationReferencedObject'        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.62.00',

  // Annex A.2 - Preface
  'ContentStorageRef'                  : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.01.00.00',

  // Annex A.4 - Content Storage
  'Packages'                           : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.01.00.00',

  // Annex B.1 - Generic Package
  'PackageUID'                         : '06.0e.2b.34.01.01.01.01.01.01.15.10.00.00.00.00',
  'PackageCreationDate'                : '06.0e.2b.34.01.01.01.02.07.02.01.10.01.03.00.00',
  'PackageModifiedDate'                : '06.0e.2b.34.01.01.01.02.07.02.01.10.02.05.00.00',
  'Tracks'                             : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.05.00.00',

  // Annex B.6
  'TrackID'                            : '06.0e.2b.34.01.01.01.02.01.07.01.01.00.00.00.00',
  'TrackNumber'                        : '06.0e.2b.34.01.01.01.02.01.04.01.03.00.00.00.00',
  'TrackName'                          : '06.0e.2b.34.01.01.01.02.01.07.01.02.01.00.00.00',
  'SequenceRef'                        : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.04.00.00',

  // Annex B.8 - Structural Component
  'DataDefinition'                     : '06.0e.2b.34.01.01.01.02.04.07.01.00.00.00.00.00',
  'Duration'                           : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.03.00.00',

  // Annex B.9 - Sequence
  'StructuralComponents'               : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.09.00.00',

  // Annex B.12 - Timeline Track
  'EditRate'                           : '06.0e.2b.34.01.01.01.02.05.30.04.05.00.00.00.00',
  'Origin'                             : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.03.00.00',

  // Annex B.17 - Timecode component
  'StartTimecode'                      : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.05.00.00',
  'RoundedTimecodeBase'                : '06.0e.2b.34.01.01.01.02.04.04.01.01.02.06.00.00',
  'DropFrame'                          : '06.0e.2b.34.01.01.01.01.04.04.01.01.05.00.00.00',

  // Annex E.2 - Source Package
  'Descriptor'                         : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.03.00.00',

  // Annex F.2 - File descriptor
  'EssenceContainer'                   : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.02.00.00',
  'SampleRate'                         : '06.0e.2b.34.01.01.01.01.04.06.01.01.00.00.00.00',
  'ChannelCount'                       : '06.0e.2b.34.01.01.01.05.04.02.01.01.04.00.00.00',
  'QuantizationBits'                   : '06.0e.2b.34.01.01.01.04.04.02.03.03.04.00.00.00',


  // Annex F.3 - Multiple descriptor
  'SubDescriptors'                     : '06.0e.2b.34.01.01.01.04.06.01.01.04.06.0b.00.00',

  // Annex F.4.1 - Generic Picture Essence Descriptor
  'PictureEssenceCoding'               : '06.0e.2b.34.01.01.01.02.04.01.06.01.00.00.00.00',
  'LinkedTrackID'                      : '06.0e.2b.34.01.01.01.05.06.01.01.03.05.00.00.00',

  // Not sure which standard is supposed to provide these. These where found doing reverse
  // engineering using Nablets MXF analyzer
  'MPEG2PictureEssenceDescriptor'      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.51.00',
  'CDCIPictureEssenceDescriptor'       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.28.00',
  'AESAudioEssenceDescriptor'          : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.47.00',
  'WaveAudioEssenceDescriptor'         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.48.00',
  'ANCPacketsEssenceDescriptor'        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.5c.00',


  // Table 29 – Random Index Pack Key Value
  'RandomIndexPack'                    : SMPTE_UL_RANDOM_INDEX_PACK,

  // Table 25 – Specification of the Index Table Segment Key
  'IndexTableSegment'                  : SMPTE_UL_INDEX_TABLE_SEGMENT,

  // Table 26 – Index Table Segment Set
  'InstanceUID'                        : '06.0e.2b.34.01.01.01.01.01.01.15.02.00.00.00.00',
  'IndexEditRate'                      : '06.0e.2b.34.01.01.01.05.05.30.04.06.00.00.00.00',
  'IndexStartPosition'                 : '06.0e.2b.34.01.01.01.05.07.02.01.03.01.0a.00.00',
  'IndexDuration'                      : '06.0e.2b.34.01.01.01.05.07.02.02.01.01.02.00.00',
  'EditUnitByteCount'                  : '06.0e.2b.34.01.01.01.04.04.06.02.01.00.00.00.00',
  'IndexSID'                           : '06.0e.2b.34.01.01.01.04.01.03.04.05.00.00.00.00',
  'BodySID'                            : '06.0e.2b.34.01.01.01.04.01.03.04.04.00.00.00.00',
  'SliceCount'                         : '06.0e.2b.34.01.01.01.04.04.04.04.01.01.00.00.00',
  'PosTableCount'                      : '06.0e.2b.34.01.01.01.05.04.04.04.01.07.00.00.00',
  'DeltaEntryArray'                    : '06.0e.2b.34.01.01.01.05.04.04.04.01.06.00.00.00',
  'IndexEntryArray'                    : '06.0e.2b.34.01.01.01.05.04.04.04.02.05.00.00.00',
  'ExtStartOffset'                     : '06.0e.2b.34.01.01.01.0a.04.06.02.04.00.00.00.00',
  'VBEByteCount'                       : '06.0e.2b.34.01.01.01.0a.04.06.02.05.00.00.00.00',

  // Table 27 - Structure of Delta Entry Array
  'PosTableIndex'                      : '06.0e.2b.34.01.01.01.04.04.04.04.01.04.00.00.00',
  'Slice'                              : '06.0e.2b.34.01.01.01.04.04.04.04.01.02.00.00.00',
  'ElementDelta'                       : '06.0e.2b.34.01.01.01.04.04.04.04.01.03.00.00.00',

  // Table 28 – Structure of Index Entry Array
  'TemporalOffset'                     : '06.0e.2b.34.01.01.01.04.04.04.04.02.03.00.00.00',
  'KeyFrameOffset'                     : '06.0e.2b.34.01.01.01.04.04.04.04.02.04.00.00.00',
  'Flags'                              : '06.0e.2b.34.01.01.01.04.04.04.04.02.02.00.00.00',
  'StreamOffset'                       : '06.0e.2b.34.01.01.01.04.04.04.04.02.01.00.00.00',
  'SliceOffset'                        : '06.0e.2b.34.01.01.01.04.04.04.04.01.05.00.00.00',
  'PosTable'                           : '06.0e.2b.34.01.01.01.05.04.04.04.01.08.00.00.00',

  'SystemScheme1'                      : SMPTE_UL_SYSTEM_SCHEME_1,
  'STDISystemMetadata'                 : SMPTE_UL_SDTI_SYSTEM_METADATA,

  // Picture essence codings
  'AVC Baseline'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_BASELINE,
  'AVC Main'                                        : SMPTE_PICTURE_ESSENCE_CODING_AVC_MAIN,
  'AVC Extended'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_EXTENDED,
  'AVC High'                                        : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH,
  'AVC High 10'                                     : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10,
  'AVC High 422'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422,
  'AVC High 444'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444,
  'AVC High 10 Intra'                               : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA,
  'AVC High 10 Intra RP2027 Class 50 1080/59.94i'   : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_5994I,
  'AVC High 10 Intra RP2027 Class 50 1080/50i'      : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_50I,
  'AVC High 10 Intra RP2027 Class 50 1080/29.97p'   : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_2997P,
  'AVC High 10 Intra RP2027 Class 50 1080/25p'      : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_25P,
  'AVC High 10 Intra RP2027 Class 50 720/59.94p'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_5994P,
  'AVC High 10 Intra RP2027 Class 50 720/50p'       : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_50P,
  'AVC High 422 Intra'                              : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA,
  'AVC High 422 Intra RP2027 Class 100 1080/59.94i' : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_5994I,
  'AVC High 422 Intra RP2027 Class 100 1080/50i'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_50I,
  'AVC High 422 Intra RP2027 Class 100 1080/29.97p' : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_2997P,
  'AVC High 422 Intra RP2027 Class 100 1080/25p'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_25P,
  'AVC High 422 Intra RP2027 Class 100 720/59.94p'  : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_5994P,
  'AVC High 422 Intra RP2027 Class 100 720/50p'     : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_50P,
  'AVC High 444 Intra'                              : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444_INTRA,
  'AVC CAVLC 444'                                   : SMPTE_PICTURE_ESSENCE_CODING_AVC_CAVLC_444,
};

// Summary of 9.2 Primer Pack:
// The Primer pack should only cover local tags for the same header/footer
// partition. Because the body partitions may contain IndexTableSegments and
// the body partitions shall not contain PrimerPack the Primer pack is NOT
// required for parsing the IndexTable. Instead all ULs in the for the fields
// in the index table segment have static hard coded local tags. These are
// defined in:
//
// Annex H (Normative)
// Static Local Tags Assigned by MXF Specifications (subset)
const INDEX_TABLE_STATIC_TAGS : Record<string, string> = {
  '3c.0a' : '06.0e.2b.34.01.01.01.01.01.01.15.02.00.00.00.00',
  '3f.0b' : '06.0e.2b.34.01.01.01.05.05.30.04.06.00.00.00.00',
  '3f.0c' : '06.0e.2b.34.01.01.01.05.07.02.01.03.01.0a.00.00',
  '3f.0d' : '06.0e.2b.34.01.01.01.05.07.02.02.01.01.02.00.00',
  '3f.05' : '06.0e.2b.34.01.01.01.04.04.06.02.01.00.00.00.00',
  '3f.06' : '06.0e.2b.34.01.01.01.04.01.03.04.05.00.00.00.00',
  '3f.07' : '06.0e.2b.34.01.01.01.04.01.03.04.04.00.00.00.00',
  '3f.08' : '06.0e.2b.34.01.01.01.04.04.04.04.01.01.00.00.00',
  '3f.0e' : '06.0e.2b.34.01.01.01.05.04.04.04.01.07.00.00.00',
  '3f.09' : '06.0e.2b.34.01.01.01.05.04.04.04.01.06.00.00.00',
  '3f.0a' : '06.0e.2b.34.01.01.01.05.04.04.04.02.05.00.00.00',
  '3f.0f' : '06.0e.2b.34.01.01.01.0a.04.06.02.04.00.00.00.00',
  '3f.10' : '06.0e.2b.34.01.01.01.0a.04.06.02.05.00.00.00.00',
};
